import { render, staticRenderFns } from "./customerlistreport.vue?vue&type=template&id=162d1dee&"
import script from "./customerlistreport.vue?vue&type=script&lang=js&"
export * from "./customerlistreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports